import { State } from './selector';
import { isObjectDeeplyChanged } from '../../util/state';

/**
 * @param state the new state
 * @param oldState the old state
 * @returns the state is changed or not
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const { formData, responseData, lmError, isAvailabilityChecked } = state;
    const isFormChanged = isObjectDeeplyChanged(oldState.formData, formData);
    const availabilityChanged = isAvailabilityChecked !== oldState.isAvailabilityChecked;

    return {
        avc: availabilityChanged,
        form: isFormChanged,
        lmResult: responseData !== oldState.responseData,
        lmError: lmError !== oldState.lmError,
    };
};
